import styled from "styled-components";

import { colors, borderRadius, skeletonKeyframes } from "shared/styles/constants";

export const StyledSkeleton = styled.span`
  display: inline-block;

  width: 100%;

  background-color: ${colors.grey1};
  background-image: linear-gradient(90deg, ${colors.grey1}, ${colors.grey2}, ${colors.grey1});
  background-size: 200px 100%;
  background-repeat: no-repeat;

  border-radius: ${borderRadius.m};

  color: transparent;

  animation: ${skeletonKeyframes} 1.2s ease-in-out infinite;
`;
